import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import {
  isDemoUser,
  maskDemoData,
  maskDemoValue,
  DEMO_EMPRESA_NOMBRE,
  SOS_DEMO_USER_ID,
} from "./utils/demoMask";
import "./assets/styles.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueProgressBar from "vue-progressbar";
import VueSweetalert2 from "vue-sweetalert2";
import * as VueGoogleMaps from "vue2-google-maps";
import "sweetalert2/dist/sweetalert2.min.css";
import { VueSpinners } from "@saeris/vue-spinners";
import HighchartsVue from 'highcharts-vue'
import Highcharts from "highcharts";
import * as HichartsExporting from 'highcharts/modules/exporting';
import * as HichartsExportingData from 'highcharts/modules/export-data';
import * as HichartsOfflineExporting from 'highcharts/modules/offline-exporting';
import SeriesLabel from "highcharts/modules/series-label";
import HC_more from 'highcharts/highcharts-more';
import Vuelidate from "vuelidate";
import VuePivottable from "vue-pivottable";
import "vue-pivottable/dist/vue-pivottable.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { VueReCaptcha } from 'vue-recaptcha-v3';
// import VueGoogleHeatmap from "vue-google-heatmap";

HC_more(Highcharts);
SeriesLabel(Highcharts);
HichartsExporting(Highcharts);
HichartsExportingData(Highcharts);
HichartsOfflineExporting(Highcharts);

const optionsProgress = {
  color: "#00529c",
  thickness: "5px",
  autoRevert: true,
};

const optionsSwal = {
  confirmButtonColor: "#b0c442",
  cancelButtonColor: "#00529c",
};

Vue.use(HighchartsVue);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCHeKQcUexgFjAZPwHdSqRX7ofAX4DSv6c",
    libraries: ["places", "geometry"],
  },
});

// Vue.use(VueGoogleHeatmap, {
//   apiKey: "AIzaSyCHeKQcUexgFjAZPwHdSqRX7ofAX4DSv6c",
// });

Vue.use(VueProgressBar, optionsProgress);
Vue.use(VueSweetalert2, optionsSwal);
Vue.use(VueSpinners);
Vue.use(VuePivottable);
Vue.use(Vuelidate);

// Configurar reCAPTCHA v3
Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_CAPTCHA_KEY || 'tu_site_key_aqui',
  loaderOptions: {
    useRecaptchaNet: true,
    autoHideBadge: false
  }
});

Vue.component('date-picker', DatePicker);
Vue.component("v-select", vSelect);
Vue.config.productionTip = false;

Vue.filter("demoEmpresa", function (value) {
  const user = store.getters.getUser;
  return maskDemoValue(value, user);
});

Vue.prototype.$demoEmpresa = function (value) {
  return maskDemoValue(value, store.getters.getUser);
};

Vue.prototype.$isDemoUser = function () {
  return isDemoUser(store.getters.getUser);
};

Vue.prototype.$demoEmpresaNombre = DEMO_EMPRESA_NOMBRE;

function resolveDemoUser(response) {
  const user = store.getters.getUser;
  if (isDemoUser(user)) {
    return user;
  }
  const data = response && response.data;
  if (data && data.id === SOS_DEMO_USER_ID) {
    return { id: SOS_DEMO_USER_ID };
  }
  return null;
}

// Enmascarar nombres de empresa/cliente en respuestas API (usuario demo id 78)
axios.interceptors.response.use(
  (response) => {
    const demoUser = resolveDemoUser(response);
    if (demoUser && response.data) {
      maskDemoData(response.data, demoUser);
    }
    return response;
  },
  (error) => Promise.reject(error)
);

// Interceptor inteligente para manejar sesiones expiradas
axios.interceptors.response.use(
  response => response,
  error => {
    // Solo procesar errores 401
    if (error.response && error.response.status === 401) {
      const isUserAuthenticated = store.getters.isAuthenticated;
      const isLoginRequest = error.config && error.config.url && 
                           (error.config.url.includes('/login') || 
                            error.config.url.includes('/api/user') ||
                            error.config.url.includes('/api/menu') ||
                            error.config.url.includes('/api/user/permissions'));
      
      // SOLO hacer logout automático si:
      // 1. El usuario ESTABA autenticado (tenía sesión válida)
      // 2. NO es una request de login o carga inicial
      // 3. Estamos navegando dentro de la aplicación (no en login)
      const shouldLogout = isUserAuthenticated && 
                          !isLoginRequest && 
                          window.location.pathname !== '/login';
      
      if (shouldLogout) {
        // Evitar múltiples calls de logout simultáneos
        store.dispatch('logout').catch(() => {
          // Manejar errores de navegación duplicada silenciosamente
        });
        return Promise.reject(error);
      }
    }
    
    return Promise.reject(error);
  }
);

// Detección más robusta de sesión existente
function hasValidSession() {
  try {
    // Verificar cookie de sesión de Laravel
    const hasLaravelSession = document.cookie.split(';').some(cookie => 
      cookie.trim().startsWith('laravel_session=') && 
      cookie.trim().length > 'laravel_session='.length
    );
    
    // Verificar estado persistido en Vuex
    const vuexState = localStorage.getItem('vuex');
    let hasStoredAuth = false;
    
    if (vuexState) {
      try {
        const parsed = JSON.parse(vuexState);
        hasStoredAuth = parsed.auth === true && parsed.user !== null;
      } catch (e) {
        // Si no se puede parsear, asumir que no hay sesión válida
        hasStoredAuth = false;
      }
    }
    
    return hasLaravelSession || hasStoredAuth;
  } catch (error) {
    return false;
  }
}

// Verificar si hay sesión válida y limpiar estados inconsistentes
if (!hasValidSession()) {
  // Limpiar cualquier estado persistido inválido
  const vuexState = localStorage.getItem('vuex');
  if (vuexState) {
    try {
      const parsed = JSON.parse(vuexState);
      if (parsed.auth === true || parsed.user !== null) {
        localStorage.removeItem('vuex');
      }
    } catch (e) {
      // Si no se puede parsear, limpiar
      localStorage.removeItem('vuex');
    }
  }
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
